/* unplugin-vue-components disabled */
import {Users} from 'stores/users.js'
import {DataTable, Column} from 'components/data-table'
import Rest from 'utils/rest'
import {API2_USERS} from 'consts/api2'
import $profile from 'stores/profile'
import EditProfileModal from './edit-profile-modal.vue'

export default {
  components: {DataTable, Column, EditProfileModal},
  data() {
    return {
      store: new Users(),
      loading: true,
      selected_user: undefined,
      saving_user: false,
      load_params: this.defParams()
    }
  },
  computed: {
    API2_USERS() {
      return API2_USERS
    },
    refreshing() {
      return this.store.loading
    },
    view_items() {
      return this.store.view_items
    },
    view_total() {
      return this.store.view_total
    }
  },
  async mounted() {
    this.loading = true
    await this.store.load({...this.load_params, tenant_id: $profile.tenant_id})
    this.loading = false
  },
  methods: {
    defParams() {
      return {skip: 0, limit: 20, tenant_id: $profile.tenant_id}
    },
    async onSearch(filter) {
      const load_params = {...this.defParams(), filter}
      await this.store.load(load_params)
      this.load_params = load_params
    },
    async onPage(ev) {
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows, tenant_id: $profile.tenant_id}
      await this.store.load(this.load_params)
    },
    async onDownloadFollowed(user_id) {
      const rest = new Rest({json: false})
      let csv
      try {
        csv = await rest.get(`${API2_USERS}/${user_id}/download-followed`)
      }
      catch(err) {
        $utils.toasts.error('User has no followed entities')
        return
      }
      $utils.stringToFile(csv, `followed-entities-${user_id}.csv`, 'text/csv')

    },
  }
}
